import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form, Table } from 'react-bootstrap';
import { filter, isEqual, isEmpty, includes } from 'lodash';
import uuid from 'uuid/v1';

import { SYMBOLOGY_TYPES } from '../../../api/Styles/Styles';

import ColorPicker from '../ColorPicker';
import TablePagination from '../TablePagination';

const VALUES_PER_PAGE = 6;

const PropertyValuesRows = ({ legend, alpha, changeCustomStatus, changeCustomLegend }) =>
  legend.map(colorStep => (
    <tr key={uuid()}>
      <td>{colorStep.index}</td>
      <td>{`${colorStep.value}`}</td>
      <td>{colorStep.count}</td>
      <td>
        <ColorPicker
          color={colorStep.color || '#fff'}
          alpha={alpha || 1}
          disableAlpha
          isTable
          updateColor={rgbColor => {
            changeCustomLegend(colorStep.index, rgbColor);
            changeCustomStatus(true);
          }}
        />
      </td>
    </tr>
  ));

PropertyValuesRows.propTypes = {
  legend: PropTypes.array.isRequired,
  alpha: PropTypes.number.isRequired,
  changeCustomStatus: PropTypes.func.isRequired,
  changeCustomLegend: PropTypes.func.isRequired
};

class SymbologyDataPreviewTable extends Component {
  state = {
    currentPage: 1
  };

  componentDidUpdate(prevProps) {
    const { legend } = this.props;
    const { legend: prevLegend } = prevProps;

    if (!isEqual(legend, prevLegend)) {
      this.changePage(1);
    }
  }

  changePage = pageNumber => {
    this.setState({ currentPage: pageNumber });
  };

  render() {
    const {
      symbologyType,
      legend,
      alpha,
      changeCustomStatus,
      changeCustomLegend,
      hasTitle
    } = this.props;
    const { currentPage } = this.state;
    const skip = currentPage * VALUES_PER_PAGE - VALUES_PER_PAGE;
    const colorStepsToRender = filter(
      legend,
      (legendField, index) => index >= skip && index < skip + VALUES_PER_PAGE
    );
    const tablePaginationProps = {
      totalCount: legend.length,
      itemsPerPage: VALUES_PER_PAGE,
      currentPage,
      changePage: this.changePage
    };

    if (
      includes([SYMBOLOGY_TYPES.NUMERIC, SYMBOLOGY_TYPES.CATEGORIZED], symbologyType) &&
      isEmpty(legend)
    )
      return '';

    return (
      <Form.Group style={{ position: 'relative' }}>
        {hasTitle && <Form.Label>Data Preview</Form.Label>}
        <Table responsive size="sm" className="text-center">
          <thead>
            <tr>
              <th>#</th>
              <th>Value</th>
              <th>Count</th>
              <th>Color</th>
            </tr>
          </thead>
          <tbody>
            <PropertyValuesRows
              legend={colorStepsToRender}
              alpha={alpha}
              changeCustomStatus={changeCustomStatus}
              changeCustomLegend={changeCustomLegend}
            />
          </tbody>
        </Table>
        <TablePagination {...tablePaginationProps} isPaginationOn />
      </Form.Group>
    );
  }
}
SymbologyDataPreviewTable.defaultProps = {
  hasTitle: true
};
SymbologyDataPreviewTable.propTypes = {
  hasTitle: PropTypes.bool,
  symbologyType: PropTypes.string.isRequired,
  legend: PropTypes.array.isRequired,
  alpha: PropTypes.number.isRequired,
  changeCustomStatus: PropTypes.func.isRequired,
  changeCustomLegend: PropTypes.func.isRequired
};

export default SymbologyDataPreviewTable;
